import React from 'react';
export var FormatHtmlText = function FormatHtmlText(_ref) {
  var formatHtmlText = _ref.formatHtmlText,
    groupStyle = _ref.groupStyle;
  var combinedText = formatHtmlText.map(function (statement, idx) {
    return /*#__PURE__*/React.createElement("span", {
      key: idx,
      style: statement.style
    }, statement.text);
  });
  return /*#__PURE__*/React.createElement("div", {
    style: groupStyle
  }, combinedText);
};
export default FormatHtmlText;